import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Row, Alert, Col } from 'react-bootstrap';
import FormBusca from './form_busca';
import EducacaoService from '../../../services/contasEducacao'
import Receita from './receita';

const ListarReceitas = () => {

    const [receitas, setReceitas] = useState([]);
    const [vazio, setVazio] = useState(false);

    async function fetchReceitas() {
        const response = await EducacaoService.listarReceitas();
        if (response.data.length >= 1) {
            setReceitas(response.data)
            setVazio(false)
        } else {
            setReceitas([])
            setVazio(true)
        }
    }

    useEffect(() => {
        fetchReceitas();
    }, []);

    return (
        <Fragment>
            <Fragment>
                <FormBusca
                    setReceitas={setReceitas}
                    setVazio={setVazio}
                    fetchReceitas={fetchReceitas}
                    receitas={receitas}
                />
            </Fragment>

            {vazio ? <Fragment>
                <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
            </Fragment> :
                <Fragment>
                    <br/>
                    <h5>Arrecadação da Secretaria Municipal de Educação</h5>
                    <Row xs={1} lg={3}>
                        {receitas.map((receita, index) =>
                            <Receita
                                receita={receita}
                                key={index}
                            />
                        )}
                    </Row>
                </Fragment>}
        </Fragment>

    )
}

export default ListarReceitas;